/** Pill tags shared with home Selected Designs and case study hero badges. */
export const badgePillClass = (filled: boolean) =>
  [
    'relative inline-flex shrink-0 items-center justify-center rounded-full px-2.5 py-1.5 text-[12px] leading-[12px] font-normal tracking-normal text-[var(--foreground)]',
    filled
      ? 'border border-[#d6d6d6] bg-[#ffffff]'
      : 'border border-[#d6d6d6] bg-[var(--background)]',
  ].join(' ')
